// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1Zul_","Error":"Auth_Error__BkJd8"};